import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

// GET /contract
export async function getContractsNew(queryParams = "") {
  return await instance({ baseURL }).get("/contract" + queryParams);
}

// GET /contract/:id
export async function getContractNewById(id) {
  return await instance({ baseURL }).get(`/contract/${id}`);
}

// POST /contract/create
export async function createContractNew(body) {
  return await instance({ baseURL }).post("/contract/create", body);
}

// PATCH /contract/update/:id
export async function updateContractNew(id, body) {
  return await instance({ baseURL }).patch(`/contract/update/${id}`, body);
}

// POST /contract/:id/submit
export async function submitContract(id) {
  return await instance({ baseURL }).post(`/contract/${id}/submit`);
}

// POST /contract/:id/approve
export async function approveContract(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/approve`, body);
}

// POST /contract/:id/reject
export async function rejectContract(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/reject`, body);
}

// POST /contract/:id/activate
export async function activateContract(id) {
  return await instance({ baseURL }).post(`/contract/${id}/activate`);
}

// POST /contract/:id/terminate
export async function terminateContract(id) {
  return await instance({ baseURL }).post(`/contract/${id}/terminate`);
}

// DELETE /contract/:id
export async function deleteContract(id) {
  return await instance({ baseURL }).delete(`/contract/${id}`);
}

// POST /contract/:id/amend
export async function amendContract(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/amend`, body);
}

// POST /contract/:id/units
export async function addContractUnits(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/units`, body);
}

// GET /contract/:id/costs
export async function getContractCosts(id) {
  return await instance({ baseURL }).get(`/contract/${id}/costs`);
}

// POST /contract/:id/costs
export async function addContractCosts(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/costs`, body);
}

// PATCH /contract/:id/costs/:costId
export async function updateContractCost(id, costId, body) {
  return await instance({ baseURL }).patch(`/contract/${id}/costs/${costId}`, body);
}

// DELETE /contract/:id/costs/:costId
export async function deleteContractCost(id, costId) {
  return await instance({ baseURL }).delete(`/contract/${id}/costs/${costId}`);
}

// PUT /contract/:id/revenue-scheme
export async function setRevenueScheme(id, body) {
  return await instance({ baseURL }).put(`/contract/${id}/revenue-scheme`, body);
}

// POST /contract/:id/parties
export async function addContractParties(id, body) {
  return await instance({ baseURL }).post(`/contract/${id}/parties`, body);
}

// PATCH /contract/:id/parties/:partyId
export async function updateContractParty(id, partyId, body) {
  return await instance({ baseURL }).patch(`/contract/${id}/parties/${partyId}`, body);
}

// DELETE /contract/:id/parties/:partyId
export async function deleteContractParty(id, partyId) {
  return await instance({ baseURL }).delete(`/contract/${id}/parties/${partyId}`);
}

// GET /contract/:id/versions
export async function getContractVersions(id) {
  return await instance({ baseURL }).get(`/contract/${id}/versions`);
}

// GET /contract/:id/services
export async function getContractServices(id) {
  return await instance({ baseURL }).get(`/contract/${id}/services`);
}

// PUT /contract/:id/services
export async function setContractServices(id, body) {
  return await instance({ baseURL }).put(`/contract/${id}/services`, body);
}

// ── ServiceUnit ───────────────────────────────────────────
// GET /contract/:contractId/services/:serviceId/units
export async function getServiceUnits(contractId, serviceId) {
  return await instance({ baseURL }).get(`/contract/${contractId}/services/${serviceId}/units`);
}
// POST /contract/:contractId/services/:serviceId/units
export async function addServiceUnit(contractId, serviceId, body) {
  return await instance({ baseURL }).post(`/contract/${contractId}/services/${serviceId}/units`, body);
}
// DELETE /contract/:contractId/services/:serviceId/units/:unitId
export async function removeServiceUnit(contractId, serviceId, unitId) {
  return await instance({ baseURL }).delete(`/contract/${contractId}/services/${serviceId}/units/${unitId}`);
}

// ── ContractCostPeriod ────────────────────────────────────
// GET /contract/:contractId/services/:serviceId/periods
export async function getCostPeriods(contractId, serviceId) {
  return await instance({ baseURL }).get(`/contract/${contractId}/services/${serviceId}/periods`);
}
// POST /contract/:contractId/services/:serviceId/periods
export async function createCostPeriod(contractId, serviceId, body) {
  return await instance({ baseURL }).post(`/contract/${contractId}/services/${serviceId}/periods`, body);
}
// PATCH /contract/:contractId/services/:serviceId/periods/:periodId
export async function updateCostPeriod(contractId, serviceId, periodId, body) {
  return await instance({ baseURL }).patch(`/contract/${contractId}/services/${serviceId}/periods/${periodId}`, body);
}
// DELETE /contract/:contractId/services/:serviceId/periods/:periodId
export async function deleteCostPeriod(contractId, serviceId, periodId) {
  return await instance({ baseURL }).delete(`/contract/${contractId}/services/${serviceId}/periods/${periodId}`);
}

// ── ContractCost (under period) ───────────────────────────
// GET /cost-period/:periodId/costs
export async function getPeriodCosts(periodId) {
  return await instance({ baseURL }).get(`/cost-period/${periodId}/costs`);
}
// POST /cost-period/:periodId/costs
export async function addPeriodCost(periodId, body) {
  return await instance({ baseURL }).post(`/cost-period/${periodId}/costs`, body);
}
// PATCH /contract-cost/:costId
export async function updatePeriodCost(costId, body) {
  return await instance({ baseURL }).patch(`/contract-cost/${costId}`, body);
}
// DELETE /contract-cost/:costId
export async function deletePeriodCost(costId) {
  return await instance({ baseURL }).delete(`/contract-cost/${costId}`);
}

// ── ContractCostUnit ──────────────────────────────────────
// GET /contract-cost/:costId/units
export async function getCostUnits(costId) {
  return await instance({ baseURL }).get(`/contract-cost/${costId}/units`);
}
// POST /contract-cost/:costId/units
export async function addCostUnit(costId, body) {
  return await instance({ baseURL }).post(`/contract-cost/${costId}/units`, body);
}
// PATCH /contract-cost/:costId/units/:unitId
export async function updateCostUnit(costId, unitId, body) {
  return await instance({ baseURL }).patch(`/contract-cost/${costId}/units/${unitId}`, body);
}
// DELETE /contract-cost/:costId/units/:unitId
export async function deleteCostUnit(costId, unitId) {
  return await instance({ baseURL }).delete(`/contract-cost/${costId}/units/${unitId}`);
}

// ── Contract Invoice ──────────────────────────────────────
// POST /contract-invoice/periods/:periodId/generate
export async function generatePeriodInvoices(periodId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).post(`/contract-invoice/periods/${periodId}/generate${q ? "?" + q : ""}`);
}
// POST /contract-invoice/contracts/:contractId/generate-all
export async function generateAllContractInvoices(contractId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).post(`/contract-invoice/contracts/${contractId}/generate-all${q ? "?" + q : ""}`);
}
// POST /contract-invoice/contracts/:contractId/regen-draft
// Hapus semua DRAFT invoice lama → re-generate dengan cost terkini (pasca-addendum)
export async function regenDraftContractInvoices(contractId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).post(`/contract-invoice/contracts/${contractId}/regen-draft${q ? "?" + q : ""}`);
}

// GET /contract-invoice/contracts/:contractId
export async function getContractInvoices(contractId) {
  return await instance({ baseURL }).get(`/contract-invoice/contracts/${contractId}`);
}
// GET /contract-invoice/periods/:periodId
export async function getPeriodInvoices(periodId) {
  return await instance({ baseURL }).get(`/contract-invoice/periods/${periodId}`);
}
// PATCH /contract-invoice/:invoiceId/status
export async function updateInvoiceStatus(invoiceId, status) {
  return await instance({ baseURL }).patch(`/contract-invoice/${invoiceId}/status`, { status });
}

// POST /contract-invoice/contracts/:contractId/billing-items/generate — hitung & simpan item tagihan dari cost PKS
export async function generateBillingItems(contractId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).post(`/contract-invoice/contracts/${contractId}/billing-items/generate${q ? "?" + q : ""}`);
}
// GET /contract-invoice/contracts/:contractId/billing-items?status= — daftar item tagihan tersimpan yang bisa dipilih
export async function getBillingItems(contractId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).get(`/contract-invoice/contracts/${contractId}/billing-items${q ? "?" + q : ""}`);
}
// POST /contract-invoice/contracts/:contractId/billing-items/invoice — rakit invoice dari item terpilih ({ itemIds })
export async function createInvoiceFromBillingItems(contractId, body) {
  return await instance({ baseURL }).post(`/contract-invoice/contracts/${contractId}/billing-items/invoice`, body);
}

// GET /contract-invoice/contracts/:contractId/utility-reading-schedule
export async function getUtilityReadingSchedule(contractId) {
  return await instance({ baseURL }).get(`/contract-invoice/contracts/${contractId}/utility-reading-schedule`);
}
// POST /contract-invoice/contracts/:contractId/regen-utility-reading-schedule
export async function regenUtilityReadingSchedule(contractId) {
  return await instance({ baseURL }).post(`/contract-invoice/contracts/${contractId}/regen-utility-reading-schedule`);
}
// GET /contract/:id/utility-records — unified ElectricityRecord + WaterRecord jadwal
export async function getContractUtilityRecords(contractId) {
  return await instance({ baseURL }).get(`/contract/${contractId}/utility-records`);
}
// PATCH /contract-invoice/utility-reading/:id
export async function inputMeterReading(id, body) {
  return await instance({ baseURL }).patch(`/contract-invoice/utility-reading/${id}`, body);
}
// PATCH /contract-invoice/utility-reading/:id/verify
export async function verifyMeterReading(id, body) {
  return await instance({ baseURL }).patch(`/contract-invoice/utility-reading/${id}/verify`, body);
}

// ── Contract Sales Recap Schedule ──────────────────────────────────────────────
// POST /contract-sales-recap/contracts/:contractId/generate
export async function generateSalesRecapSchedule(contractId, params = {}) {
  const q = new URLSearchParams(params).toString();
  return await instance({ baseURL }).post(`/contract-sales-recap/contracts/${contractId}/generate${q ? "?" + q : ""}`);
}
// GET /contract-sales-recap/contracts/:contractId?status=
export async function getContractSalesRecapSchedule(contractId, status = "") {
  const q = status ? `?status=${status}` : "";
  return await instance({ baseURL }).get(`/contract-sales-recap/contracts/${contractId}${q}`);
}
// PATCH /contract-sales-recap/:scheduleId/submit
export async function submitSalesRecapData(scheduleId, data) {
  return await instance({ baseURL }).patch(`/contract-sales-recap/${scheduleId}/submit`, data);
}
// PATCH /contract-sales-recap/:scheduleId/finalize
export async function finalizeSalesRecapData(scheduleId) {
  return await instance({ baseURL }).patch(`/contract-sales-recap/${scheduleId}/finalize`);
}
// PATCH /contract-sales-recap/:scheduleId/verify
export async function verifySalesRecapData(scheduleId, data) {
  return await instance({ baseURL }).patch(`/contract-sales-recap/${scheduleId}/verify`, data);
}
// PATCH /contract-sales-recap/:scheduleId/settle
export async function settleSalesRecap(scheduleId) {
  return await instance({ baseURL }).patch(`/contract-sales-recap/${scheduleId}/settle`);
}
// PATCH /contract-sales-recap/:scheduleId/dispute
export async function disputeSalesRecap(scheduleId, notes) {
  return await instance({ baseURL }).patch(`/contract-sales-recap/${scheduleId}/dispute`, { notes });
}
// DELETE /contract-sales-recap/:scheduleId
export async function deleteSalesRecapScheduleItem(scheduleId) {
  return await instance({ baseURL }).delete(`/contract-sales-recap/${scheduleId}`);
}
// POST /contract-sales-recap/:scheduleId/generate-invoice
export async function generateInvoiceFromSalesRecap(scheduleId) {
  return await instance({ baseURL }).post(`/contract-sales-recap/${scheduleId}/generate-invoice`);
}
// POST /contract-sales-recap/:scheduleId/generate-billing-item
export async function generateBillingItemFromSalesRecap(scheduleId) {
  return await instance({ baseURL }).post(`/contract-sales-recap/${scheduleId}/generate-billing-item`);
}
